import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { showAlert } from "../../store/actions/AppAction";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import DoneIcon from "@material-ui/icons/Done";
import Tooltip from "@material-ui/core/Tooltip";
import Detalhe from "./Detalhe";
import Aprovacao from "./Aprovacao";
import Contestar from "./Contestar";
import { getFatura, getFaturaItens } from "../../services/FaturamentoService";
import { getUsuarioByToken } from "../../services/UsuarioService";
import Blocker from "../../components/Blocker";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import IconButton from "@material-ui/core/IconButton";
import GetAppIcon from "@material-ui/icons/GetApp";
import TextsmsIcon from "@material-ui/icons/Textsms";
import Chip from "@material-ui/core/Chip";
import { BASE_URL_PDF_EXCEL } from "../../store/constants/AppConstants";

const PERFIL_USUARIO_UNIDATA = 1;
const PERFIL_USUARIO_COMERCIAL = 76;
const PERFIL_USUARIO_FINANCEIRO = 77;

const STATUS_FATURA_CRIADA = 0;
const STATUS_FATURA_ENVIADA_AO_GESTOR = 1;
const STATUS_FATURA_CONTESTADA = 2;
const STATUS_FATURA_CONTESTACAO_RESPONDIDA = 3;
const STATUS_FATURA_ACEITA_PELO_GESTOR = 4;
const STATUS_FATURA_ENVIADA_PARA_FATURAMENTO = 5;
const STATUS_FATURA_FATURADA = 6;
const STATUS_FATURA_PAGA = 7;
const STATUS_FATURA_CANCELADA_POR_CONTESTACAO = 8;

const styles = theme => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing.unit * 1
  },
  button: {
    margin: theme.spacing(1)
  },
  leftIcon: {
    marginRight: theme.spacing(1)
  },
  rightIcon: {
    marginLeft: theme.spacing(1)
  },
  iconSmall: {
    fontSize: 20
  },
  title: {
    flexGrow: 1
  },
  rootRow: {
    "&:nth-of-type(odd)": {
      backgroundColor: "#fdfdfd"
    }
  }
});

class Faturamento extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openAprovacao: false,
      openReprovacao: false,
      openDetalhe: false,
      dados: {},
      itens: [],
      submitting: false,
      usuarioLogado: {},
      mensagemErro: ""
    };
  }

  componentDidMount() {
    this.getFatura();
  }

  getFatura = () => {
    this.setState(
      {
        submitting: true,
        openAprovacao: false,
        openReprovacao: false
      },
      () => {
        getUsuarioByToken()
          .then(result => {
            this.setState(
              {
                usuarioLogado: result.data
              },
              () => {
                let params = { uuid: this.props.match.params.id };

                sessionStorage.setItem("fatura", this.props.match.params.id);

                getFatura(params)
                  .then(result => {
                    this.setState({
                      dados: result.data,
                      submitting: false
                    });
                  })
                  .catch(error => {
                    this.setState({
                      mensagemErro: error.message.error,
                      dados: {},
                      submitting: false
                    });
                    console.log(error);
                  });
              }
            );
          })
          .catch(error => {
            this.setState({
              usuarioLogado: {},
              submitting: false,
              dados: {}
            });
            console.log(error);
          });
      }
    );
  };

  handleClickOpenDetalhePDF = () => {
    window.open(
      BASE_URL_PDF_EXCEL +
      "getPDF?uuid=" +
      this.props.match.params.id +
      "&token=" +
      sessionStorage.getItem("token"),
      "_blank"
    );
  };

  handleClickOpenDetalheEXCEL = () => {
    window.open(
      BASE_URL_PDF_EXCEL +
      "getExcel?uuid=" +
      this.props.match.params.id +
      "&token=" +
      sessionStorage.getItem("token"),
      "_blank"
    );
  };

  handleCloseDetalhe = () => {
    this.setState({ openDetalhe: false });
  };

  handleClickOpenAprovacao = () => {
    this.setState({
      openAprovacao: true
    });
  };

  handleCloseAprovacao = () => {
    this.setState({ openAprovacao: false });
  };

  handleClickOpenReprovacao = () => {
    this.setState({
      openReprovacao: true
    });
  };

  handleCloseReprovacao = () => {
    this.setState({ openReprovacao: false });
  };

  isEnableAprovacao = () => {
    return (
      this.state.dados.FATU_STATUS === STATUS_FATURA_ENVIADA_AO_GESTOR ||
      this.state.dados.FATU_STATUS === STATUS_FATURA_CONTESTACAO_RESPONDIDA
    );
  };

  isEnableContestar = () => {
    return (
      (this.state.dados.FATU_STATUS === STATUS_FATURA_ENVIADA_AO_GESTOR &&
        this.state.usuarioLogado.PerfCodigo === 3) ||
      (this.state.dados.FATU_STATUS === STATUS_FATURA_CONTESTADA &&
        this.state.usuarioLogado.PerfCodigo === PERFIL_USUARIO_UNIDATA) ||
      (this.state.dados.FATU_STATUS === STATUS_FATURA_CONTESTACAO_RESPONDIDA &&
        this.state.usuarioLogado.PerfCodigo === 3)
    );
  };

  isFaturaAprovada = () => {
    return this.state.dados.FATU_STATUS >= STATUS_FATURA_ACEITA_PELO_GESTOR;
  };

  isUsuarioAprova = () => {
    return (
      this.state.usuarioLogado &&
      (this.state.usuarioLogado.PerfCodigo !== PERFIL_USUARIO_UNIDATA &&
        this.state.usuarioLogado.PerfCodigo !== PERFIL_USUARIO_COMERCIAL &&
        this.state.usuarioLogado.PerfCodigo !== PERFIL_USUARIO_FINANCEIRO) &&
      this.state.usuarioLogado.UsuaAprovaPreFatura.toUpperCase() === "S"
    );
  };

  isUsuarioResponde = () => {
    return (
      this.state.usuarioLogado &&
      (this.state.usuarioLogado.PerfCodigo === PERFIL_USUARIO_UNIDATA ||
        this.state.usuarioLogado.PerfCodigo === PERFIL_USUARIO_COMERCIAL ||
        this.state.usuarioLogado.PerfCodigo === PERFIL_USUARIO_FINANCEIRO)
    );
  };

  exibeStatusFatura = () => {
    var mensagem = "";
    switch (this.state.dados.FATU_STATUS) {
      case STATUS_FATURA_ENVIADA_AO_GESTOR:
        mensagem = "Aguardando Aprovação Gestor do Órgão";
        break;
      case STATUS_FATURA_CONTESTADA:
        mensagem = "Contestação do Gestor do Órgão";
        break;
      case STATUS_FATURA_CONTESTACAO_RESPONDIDA:
        mensagem = "Contestação respondida pela Unidata";
        break;
      case STATUS_FATURA_ACEITA_PELO_GESTOR:
        mensagem = "Aguardando Emissão Pedido de Faturamento";
        break;
      case STATUS_FATURA_ENVIADA_PARA_FATURAMENTO:
        mensagem = "Aguardando Emissão da Fatura";
        break;
      case STATUS_FATURA_FATURADA:
        mensagem = "Fatura enviada para Órgão";
        break;
      case STATUS_FATURA_PAGA:
        mensagem = "Fatura Paga";
        break;
      case STATUS_FATURA_CANCELADA_POR_CONTESTACAO:
        mensagem = "Cancelada por contestação";
        break;
    }

    return <font color="red">{mensagem}</font>;
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <Aprovacao
          getFatura={this.getFatura}
          fatura={this.state.dados.FATU_CODIGO}
          orgao={this.state.dados.ORGA_CODIGO}
          open={this.state.openAprovacao}
          close={this.handleCloseAprovacao}
        />
        <Contestar
          getFatura={this.getFatura}
          isEnableContestar={this.isEnableContestar()}
          perfilUsuario={this.state.usuarioLogado.PerfCodigo}
          fatura={this.state.dados.FATU_CODIGO}
          open={this.state.openReprovacao}
          close={this.handleCloseReprovacao}
        />

        <Detalhe
          dados={this.state.dados}
          itens={this.state.itens}
          open={this.state.openDetalhe}
          close={this.handleCloseDetalhe}
        />

        <Blocker submitting={this.state.submitting}>
          <Card>
            <CardHeader
              style={{
                backgroundColor: "#efefef",
                paddingLeft: "12px",
                paddingRight: "6px",
                paddingTop: "3px",
                paddingBottom: "3px"
              }}
              action={
                <div>
                  {this.state.dados &&
                    Object.keys(this.state.dados).length > 0 && (
                      <Chip
                        label={this.state.usuarioLogado.UsuaNome}
                        className={classes.chip}
                      />
                    )}

                  {this.state.dados &&
                    Object.keys(this.state.dados).length > 0 &&
                    this.isUsuarioAprova() &&
                    !this.isFaturaAprovada() &&
                    this.isEnableAprovacao() && (
                      <Tooltip title="Aprovar">
                        <IconButton
                          style={{ color: "green" }}
                          className={classes.button}
                          onClick={this.handleClickOpenAprovacao}
                          aria-label="Aprovar"
                        >
                          <DoneIcon />
                        </IconButton>
                      </Tooltip>
                    )}

                  {this.state.dados &&
                    Object.keys(this.state.dados).length > 0 &&
                    this.isEnableContestar() && (
                      <Tooltip
                        title={
                          this.isUsuarioResponde() ? "Responder" : "Contestar"
                        }
                      >
                        <IconButton
                          disabled={
                            !(
                              this.state.dados &&
                              Object.keys(this.state.dados).length > 0
                            )
                          }
                          /*
                          style={
                            this.isUsuarioResponde() ? { color: "red" } : {}
                          }*/
                          className={classes.button}
                          onClick={this.handleClickOpenReprovacao}
                          aria-label={
                            this.isUsuarioResponde() ? "Contestar" : "Responder"
                          }
                        >
                          {this.isUsuarioResponde() ? (
                            <TextsmsIcon />
                          ) : (
                            <TextsmsIcon />
                          )}
                        </IconButton>
                      </Tooltip>
                    )}

                  {this.state.dados &&
                    Object.keys(this.state.dados).length > 0 && (
                      <Tooltip title="Baixar Pré-Fatura Detalhada">
                        <IconButton
                          disabled={
                            !(
                              this.state.dados &&
                              Object.keys(this.state.dados).length > 0
                            )
                          }
                          className={classes.button}
                          onClick={this.handleClickOpenDetalhePDF}
                          aria-label="Baixar Pré-Fatura Detalhada"
                        >
                          <img src="imagens/pdf-icon.png" />
                        </IconButton>
                      </Tooltip>
                    )}

                  {this.state.dados &&
                    Object.keys(this.state.dados).length > 0 && (
                      <Tooltip title="Baixar Relação de Veículos">
                        <IconButton
                          disabled={
                            !(
                              this.state.dados &&
                              Object.keys(this.state.dados).length > 0
                            )
                          }
                          className={classes.button}
                          onClick={this.handleClickOpenDetalheEXCEL}
                          aria-label="Baixar Relação de Veículos"
                        >
                          <img src="imagens/excel-xls-icon.png" />
                        </IconButton>
                      </Tooltip>
                    )}
                </div>
              }
              title="Relatório Analitico de Despesas"
            />

            <CardContent>
              <Grid
                container
                direction="row"
                justify="flex-start"
                alignItems="stretch"
                spacing={1}
              >
                <Grid item xs={12}>
                  {this.state.dados &&
                    Object.keys(this.state.dados).length > 0 ? (
                    <Card>
                      <CardHeader
                        subheader={
                          <div>
                            <b>Resumo da Pré-Fatura </b> -{" "}
                            {this.exibeStatusFatura()}
                          </div>
                        }
                      />
                      <CardContent>
                        <Table className={classes.table} size="small">
                          <TableBody>
                            {(this.state.usuarioLogado.PerfCodigo ==
                              PERFIL_USUARIO_UNIDATA ||
                              this.state.usuarioLogado.PerfCodigo ==
                              PERFIL_USUARIO_COMERCIAL ||
                              this.state.usuarioLogado.PerfCodigo ==
                              PERFIL_USUARIO_FINANCEIRO) && (
                                <TableRow
                                  classes={{ root: classes.rootRow }}
                                  key={"CodigoFatura"}
                                >
                                  <TableCell
                                    variant="head"
                                    component="th"
                                    scope="row"
                                  >
                                    Número da Pré-Fatura
                                  </TableCell>
                                  <TableCell
                                    style={{ fontWeight: 500 }}
                                    align="right"
                                  >
                                    {this.state.dados.FATU_CODIGO}
                                  </TableCell>
                                </TableRow>
                              )}

                            {this.state.dados.FATU_STATUS ===
                              STATUS_FATURA_CANCELADA_POR_CONTESTACAO && (
                                <TableRow
                                  classes={{ root: classes.rootRow }}
                                  key={"UsuaCancela"}
                                >
                                  <TableCell
                                    variant="head"
                                    component="th"
                                    scope="row"
                                  >
                                    <font color="red">Usuário Cancelamento</font>
                                  </TableCell>
                                  <TableCell
                                    style={{ fontWeight: 500 }}
                                    align="right"
                                  >
                                    <font color="red">
                                      {this.state.dados.USUA_NOME_CANCELAMENTO +
                                        " (" +
                                        this.state.dados.USUA_EMAIL_CANCELAMENTO +
                                        ")"}
                                    </font>
                                  </TableCell>
                                </TableRow>
                              )}

                            {this.state.dados.FATU_STATUS ===
                              STATUS_FATURA_CANCELADA_POR_CONTESTACAO && (
                                <TableRow
                                  classes={{ root: classes.rootRow }}
                                  key={"DataCancelamento"}
                                >
                                  <TableCell
                                    variant="head"
                                    component="th"
                                    scope="row"
                                  >
                                    <font color="red">Data Cancelamento</font>
                                  </TableCell>
                                  <TableCell
                                    style={{ fontWeight: 500 }}
                                    align="right"
                                  >
                                    <font color="red">
                                      {this.state.dados.FATU_DATA_CANCELAMENTO}
                                    </font>
                                  </TableCell>
                                </TableRow>
                              )}

                            {this.state.dados.FATU_STATUS !=
                              STATUS_FATURA_CANCELADA_POR_CONTESTACAO && (
                                <TableRow
                                  classes={{ root: classes.rootRow }}
                                  key={"DataAprovacao"}
                                >
                                  <TableCell
                                    variant="head"
                                    component="th"
                                    scope="row"
                                  >
                                    Data limite para aprovação
                                  </TableCell>
                                  <TableCell
                                    style={{ fontWeight: 500 }}
                                    align="right"
                                  >
                                    {this.state.dados.FATU_DATAHORA_APROVACAO}
                                  </TableCell>
                                </TableRow>
                              )}
                            <TableRow
                              classes={{ root: classes.rootRow }}
                              key={"Periodo eReferencia"}
                            >
                              <TableCell
                                variant="head"
                                component="th"
                                scope="row"
                              >
                                Periodo de Referencia
                              </TableCell>
                              <TableCell
                                style={{ fontWeight: 500 }}
                                align="right"
                              >
                                {this.state.dados.FATU_DATA_INICIO +
                                  " à " +
                                  this.state.dados.FATU_DATA_FIM}
                              </TableCell>
                            </TableRow>
                            <TableRow
                              classes={{ root: classes.rootRow }}
                              key={"Orgao"}
                            >
                              <TableCell
                                variant="head"
                                component="th"
                                scope="row"
                              >
                                Órgão
                              </TableCell>
                              <TableCell
                                style={{ fontWeight: 500 }}
                                align="right"
                              >
                                {this.state.dados.ORGA_SIGLA +
                                  " (" +
                                  this.state.dados.ORGA_CODIGO +
                                  ") - " +
                                  this.state.dados.ORGA_NOME}
                              </TableCell>
                            </TableRow>

                            {(this.state.usuarioLogado.PerfCodigo ==
                              PERFIL_USUARIO_UNIDATA ||
                              this.state.usuarioLogado.PerfCodigo ==
                              PERFIL_USUARIO_COMERCIAL ||
                              this.state.usuarioLogado.PerfCodigo ==
                              PERFIL_USUARIO_FINANCEIRO) &&
                              this.state.dados.FATU_STATUS >=
                              STATUS_FATURA_ACEITA_PELO_GESTOR &&
                              this.state.dados.FATU_STATUS !=
                              STATUS_FATURA_CANCELADA_POR_CONTESTACAO && (
                                <TableRow
                                  classes={{ root: classes.rootRow }}
                                  key={"CGC"}
                                >
                                  <TableCell
                                    variant="head"
                                    component="th"
                                    scope="row"
                                  >
                                    CNPJ
                                  </TableCell>
                                  <TableCell
                                    style={{ fontWeight: 500 }}
                                    align="right"
                                  >
                                    {this.state.dados.ORGA_CGC.replace(
                                      /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
                                      "$1.$2.$3/$4-$5"
                                    )}
                                  </TableCell>
                                </TableRow>
                              )}

                            {(this.state.usuarioLogado.PerfCodigo ==
                              PERFIL_USUARIO_UNIDATA ||
                              this.state.usuarioLogado.PerfCodigo ==
                              PERFIL_USUARIO_COMERCIAL ||
                              this.state.usuarioLogado.PerfCodigo ==
                              PERFIL_USUARIO_FINANCEIRO) &&
                              this.state.dados.FATU_STATUS >=
                              STATUS_FATURA_ACEITA_PELO_GESTOR &&
                              this.state.dados.FATU_STATUS !=
                              STATUS_FATURA_CANCELADA_POR_CONTESTACAO && (
                                <TableRow
                                  classes={{ root: classes.rootRow }}
                                  key={"Contrato"}
                                >
                                  <TableCell
                                    variant="head"
                                    component="th"
                                    scope="row"
                                  >
                                    Contrato
                                  </TableCell>
                                  <TableCell
                                    style={{ fontWeight: 500 }}
                                    align="right"
                                  >
                                    {this.state.dados.ORGA_NUMERO_CONTRATO}
                                  </TableCell>
                                </TableRow>
                              )}

                            {(this.state.usuarioLogado.PerfCodigo ==
                              PERFIL_USUARIO_UNIDATA ||
                              this.state.usuarioLogado.PerfCodigo ==
                              PERFIL_USUARIO_COMERCIAL ||
                              this.state.usuarioLogado.PerfCodigo ==
                              PERFIL_USUARIO_FINANCEIRO) &&
                              this.state.dados.FATU_STATUS >=
                              STATUS_FATURA_ACEITA_PELO_GESTOR &&
                              this.state.dados.FATU_STATUS !=
                              STATUS_FATURA_CANCELADA_POR_CONTESTACAO && (
                                <TableRow
                                  classes={{ root: classes.rootRow }}
                                  key={"Endereco"}
                                >
                                  <TableCell
                                    variant="head"
                                    component="th"
                                    scope="row"
                                  >
                                    Endereço Cobrança
                                  </TableCell>
                                  <TableCell
                                    style={{ fontWeight: 500 }}
                                    align="right"
                                  >
                                    {this.state.dados.FATU_ENDERECO_COBRANCA +
                                      " - " +
                                      this.state.dados.ORGA_MUNICIPIO_COBRANCA}
                                  </TableCell>
                                </TableRow>
                              )}

                            {(this.state.usuarioLogado.PerfCodigo ==
                              PERFIL_USUARIO_UNIDATA ||
                              this.state.usuarioLogado.PerfCodigo ==
                              PERFIL_USUARIO_COMERCIAL ||
                              this.state.usuarioLogado.PerfCodigo ==
                              PERFIL_USUARIO_FINANCEIRO) &&
                              this.state.dados.FATU_STATUS >=
                              STATUS_FATURA_ACEITA_PELO_GESTOR &&
                              this.state.dados.FATU_STATUS !=
                              STATUS_FATURA_CANCELADA_POR_CONTESTACAO && (
                                <TableRow
                                  classes={{ root: classes.rootRow }}
                                  key={"Empenho"}
                                >
                                  <TableCell
                                    variant="head"
                                    component="th"
                                    scope="row"
                                  >
                                    Empenho
                                  </TableCell>
                                  <TableCell
                                    style={{ fontWeight: 500 }}
                                    align="right"
                                  >
                                    {this.state.dados.FATU_NUMERO_EMPENHO}
                                  </TableCell>
                                </TableRow>
                              )}

                            {(this.state.usuarioLogado.PerfCodigo ==
                              PERFIL_USUARIO_UNIDATA ||
                              this.state.usuarioLogado.PerfCodigo ==
                              PERFIL_USUARIO_COMERCIAL ||
                              this.state.usuarioLogado.PerfCodigo ==
                              PERFIL_USUARIO_FINANCEIRO) &&
                              this.state.dados.FATU_STATUS >=
                              STATUS_FATURA_ACEITA_PELO_GESTOR &&
                              this.state.dados.FATU_STATUS !=
                              STATUS_FATURA_CANCELADA_POR_CONTESTACAO && (
                                <TableRow
                                  classes={{ root: classes.rootRow }}
                                  key={"Gestor Aprovacao"}
                                >
                                  <TableCell
                                    variant="head"
                                    component="th"
                                    scope="row"
                                  >
                                    Gestor Aprovação
                                  </TableCell>
                                  <TableCell
                                    style={{ fontWeight: 500 }}
                                    align="right"
                                  >
                                    {this.state.dados
                                      .USUA_NOME_GESTOR_VALIDACAO +
                                      " (" +
                                      this.state.dados
                                        .USUA_EMAIL_GESTOR_VALIDACAO +
                                      ")"}
                                  </TableCell>
                                </TableRow>
                              )}

                            {(this.state.usuarioLogado.PerfCodigo ==
                              PERFIL_USUARIO_UNIDATA ||
                              this.state.usuarioLogado.PerfCodigo ==
                              PERFIL_USUARIO_COMERCIAL ||
                              this.state.usuarioLogado.PerfCodigo ==
                              PERFIL_USUARIO_FINANCEIRO) &&
                              this.state.dados.FATU_STATUS >=
                              STATUS_FATURA_ACEITA_PELO_GESTOR &&
                              this.state.dados.FATU_STATUS !=
                              STATUS_FATURA_CANCELADA_POR_CONTESTACAO && (
                                <TableRow
                                  classes={{ root: classes.rootRow }}
                                  key={"DataAprovacao"}
                                >
                                  <TableCell
                                    variant="head"
                                    component="th"
                                    scope="row"
                                  >
                                    Data Aprovação
                                  </TableCell>
                                  <TableCell
                                    style={{ fontWeight: 500 }}
                                    align="right"
                                  >
                                    {
                                      this.state.dados
                                        .FATU_DATAHORA_VALIDACAO_GESTOR
                                    }
                                  </TableCell>
                                </TableRow>
                              )}

                            <TableRow
                              classes={{ root: classes.rootRow }}
                              key={"ResponsavelIssqn"}
                            >
                              <TableCell
                                variant="head"
                                component="th"
                                scope="row"
                              >
                                Retenção de ISSQN
                              </TableCell>
                              <TableCell
                                style={{ fontWeight: 500 }}
                                align="right"
                              >
                                {this.state.dados.FATU_RESPONSAVEL_ISSQN == "T"
                                  ? "Tomador"
                                  : "Prestador"}
                              </TableCell>
                            </TableRow>
                            <TableRow
                              classes={{ root: classes.rootRow }}
                              key={"NumeroDispositivos"}
                            >
                              <TableCell
                                variant="head"
                                component="th"
                                scope="row"
                              >
                                Qtde de dispositivos
                              </TableCell>
                              <TableCell
                                style={{ fontWeight: 500 }}
                                align="right"
                              >
                                {this.state.dados.FATU_EQUIPAMENTOS_FATURADOS &&
                                  this.state.dados.FATU_EQUIPAMENTOS_FATURADOS.toLocaleString(
                                    "pt-BR",
                                    {
                                      maximumFractionDigits: 0,
                                      minimumFractionDigits: 0
                                    }
                                  )}
                              </TableCell>
                            </TableRow>
                            <TableRow
                              classes={{ root: classes.rootRow }}
                              variant="head"
                              key={"ValorTransacao"}
                            >
                              <TableCell
                                variant="head"
                                component="th"
                                scope="row"
                              >
                                Valor unitário
                              </TableCell>
                              <TableCell
                                style={{ fontWeight: 500 }}
                                align="right"
                              >
                                {this.state.dados.FATU_VALOR_TRANSACAO &&
                                  "R$ " +
                                  this.state.dados.FATU_VALOR_TRANSACAO.toLocaleString(
                                    "pt-BR",
                                    {
                                      maximumFractionDigits: 2,
                                      minimumFractionDigits: 2
                                    }
                                  )}
                              </TableCell>
                            </TableRow>
                            <TableRow
                              classes={{ root: classes.rootRow }}
                              key={"ValorServico"}
                            >
                              <TableCell
                                variant="head"
                                component="th"
                                scope="row"
                              >
                                Valor do Serviço
                              </TableCell>
                              <TableCell
                                style={{ fontWeight: 500 }}
                                align="right"
                              >
                                {this.state.dados.FATU_VALOR_SERVICO &&
                                  "R$ " +
                                  this.state.dados.FATU_VALOR_SERVICO.toLocaleString(
                                    "pt-BR",
                                    {
                                      maximumFractionDigits: 2,
                                      minimumFractionDigits: 2
                                    }
                                  )}
                              </TableCell>
                            </TableRow>
                            <TableRow
                              classes={{ root: classes.rootRow }}
                              key={"FatuImr"}
                            >
                              <TableCell
                                variant="head"
                                component="th"
                                scope="row"
                              >
                                IMR
                              </TableCell>
                              <TableCell
                                style={{ fontWeight: 500 }}
                                align="right"
                              >
                                {this.state.dados.FATU_IMR &&
                                  this.state.dados.FATU_IMR.toLocaleString(
                                    "pt-BR",
                                    {
                                      maximumFractionDigits: 2,
                                      minimumFractionDigits: 2
                                    }
                                  )}
                              </TableCell>
                            </TableRow>
                            <TableRow
                              classes={{ root: classes.rootRow }}
                              key={"AliquotaIssqn"}
                            >
                              <TableCell
                                variant="head"
                                component="th"
                                scope="row"
                              >
                                % ISSQN
                              </TableCell>
                              <TableCell
                                style={{ fontWeight: 500 }}
                                align="right"
                              >
                                {this.state.dados.FATU_ALIQUOTA_ISSQN.toLocaleString(
                                  "pt-BR",
                                  {
                                    maximumFractionDigits: 1,
                                    minimumFractionDigits: 1
                                  }
                                )}
                              </TableCell>
                            </TableRow>
                            <TableRow
                              classes={{ root: classes.rootRow }}
                              key={"IssqnRetido"}
                            >
                              <TableCell
                                variant="head"
                                component="th"
                                scope="row"
                              >
                                Valor ISSQN Retido
                              </TableCell>
                              <TableCell
                                style={{ fontWeight: 500 }}
                                align="right"
                              >
                                {this.state.dados.FATU_ISSQN_RETIDO &&
                                  "R$ " +
                                  this.state.dados.FATU_ISSQN_RETIDO.toLocaleString(
                                    "pt-BR",
                                    {
                                      maximumFractionDigits: 2,
                                      minimumFractionDigits: 2
                                    }
                                  )}
                              </TableCell>
                            </TableRow>
                            <TableRow
                              classes={{ root: classes.rootRow }}
                              key={"AliquotaIr"}
                            >
                              <TableCell
                                variant="head"
                                component="th"
                                scope="row"
                              >
                                % IRRF
                              </TableCell>
                              <TableCell
                                style={{ fontWeight: 500 }}
                                align="right"
                              >
                                {this.state.dados.FATU_ALIQUOTA_IR.toLocaleString(
                                  "pt-BR",
                                  {
                                    maximumFractionDigits: 1,
                                    minimumFractionDigits: 1
                                  }
                                )}
                              </TableCell>
                            </TableRow>
                            <TableRow
                              classes={{ root: classes.rootRow }}
                              key={"IrRetido"}
                            >
                              <TableCell
                                variant="head"
                                component="th"
                                scope="row"
                              >
                                Valor IRRF a ser retido
                              </TableCell>
                              <TableCell
                                style={{ fontWeight: 500 }}
                                align="right"
                              >
                                {this.state.dados.FATU_IR_RETIDO &&
                                  "R$ " +
                                  this.state.dados.FATU_IR_RETIDO.toLocaleString(
                                    "pt-BR",
                                    {
                                      maximumFractionDigits: 2,
                                      minimumFractionDigits: 2
                                    }
                                  )}
                              </TableCell>
                            </TableRow>

                            <TableRow
                              classes={{ root: classes.rootRow }}
                              key={"AliquotaPis"}
                            >
                              <TableCell
                                variant="head"
                                component="th"
                                scope="row"
                              >
                                Aliquota de Pis Retido
                              </TableCell>
                              <TableCell
                                style={{ fontWeight: 500 }}
                                align="right"
                              >
                                {this.state.dados.FATU_ALIQUOTA_PIS &&
                                  this.state.dados.FATU_ALIQUOTA_PIS.toLocaleString(
                                    "pt-BR",
                                    {
                                      maximumFractionDigits: 2,
                                      minimumFractionDigits: 2
                                    }
                                  )}
                              </TableCell>
                            </TableRow>

                            <TableRow
                              classes={{ root: classes.rootRow }}
                              key={"PisRetido"}
                            >
                              <TableCell
                                variant="head"
                                component="th"
                                scope="row"
                              >
                                Pis Retido
                              </TableCell>
                              <TableCell
                                style={{ fontWeight: 500 }}
                                align="right"
                              >
                                {this.state.dados.FATU_PIS_RETIDO &&
                                  "R$ " +
                                  this.state.dados.FATU_PIS_RETIDO.toLocaleString(
                                    "pt-BR",
                                    {
                                      maximumFractionDigits: 2,
                                      minimumFractionDigits: 2
                                    }
                                  )}
                              </TableCell>
                            </TableRow>

                            <TableRow
                              classes={{ root: classes.rootRow }}
                              key={"AliquotaCofins"}
                            >
                              <TableCell
                                variant="head"
                                component="th"
                                scope="row"
                              >
                                Aliquota Cofins Retido
                              </TableCell>
                              <TableCell
                                style={{ fontWeight: 500 }}
                                align="right"
                              >
                                {this.state.dados.FATU_ALIQUOTA_COFINS &&
                                  this.state.dados.FATU_ALIQUOTA_COFINS.toLocaleString(
                                    "pt-BR",
                                    {
                                      maximumFractionDigits: 2,
                                      minimumFractionDigits: 2
                                    }
                                  )}
                              </TableCell>
                            </TableRow>

                            <TableRow
                              classes={{ root: classes.rootRow }}
                              key={"CofinsRetido"}
                            >
                              <TableCell
                                variant="head"
                                component="th"
                                scope="row"
                              >
                                Cofins Retido
                              </TableCell>
                              <TableCell
                                style={{ fontWeight: 500 }}
                                align="right"
                              >
                                {this.state.dados.FATU_COFINS_RETIDO &&
                                  "R$ " +
                                  this.state.dados.FATU_COFINS_RETIDO.toLocaleString(
                                    "pt-BR",
                                    {
                                      maximumFractionDigits: 2,
                                      minimumFractionDigits: 2
                                    }
                                  )}
                              </TableCell>
                            </TableRow>

                            <TableRow
                              classes={{ root: classes.rootRow }}
                              key={"AliquotaCsll"}
                            >
                              <TableCell
                                variant="head"
                                component="th"
                                scope="row"
                              >
                                Aliquota Csll Retido
                              </TableCell>
                              <TableCell
                                style={{ fontWeight: 500 }}
                                align="right"
                              >
                                {this.state.dados.FATU_ALIQUOTA_CSLL &&
                                  this.state.dados.FATU_ALIQUOTA_CSLL.toLocaleString(
                                    "pt-BR",
                                    {
                                      maximumFractionDigits: 2,
                                      minimumFractionDigits: 2
                                    }
                                  )}
                              </TableCell>
                            </TableRow>

                            <TableRow
                              classes={{ root: classes.rootRow }}
                              key={"CsllRetido"}
                            >
                              <TableCell
                                variant="head"
                                component="th"
                                scope="row"
                              >
                                Csll Retido
                              </TableCell>
                              <TableCell
                                style={{ fontWeight: 500 }}
                                align="right"
                              >
                                {this.state.dados.FATU_CSLL_RETIDO &&
                                  "R$ " +
                                  this.state.dados.FATU_CSLL_RETIDO.toLocaleString(
                                    "pt-BR",
                                    {
                                      maximumFractionDigits: 2,
                                      minimumFractionDigits: 2
                                    }
                                  )}
                              </TableCell>
                            </TableRow>

                            <TableRow
                              classes={{ root: classes.rootRow }}
                              key={"ValorNotaFiscalapagar"}
                            >
                              <TableCell
                                variant="head"
                                component="th"
                                scope="row"
                              >
                                Valor Nota Fiscal a pagar
                              </TableCell>
                              <TableCell
                                style={{ fontWeight: 500 }}
                                align="right"
                              >
                                {this.state.dados.FATU_VALOR_NOTA_FISCAL &&
                                  "R$ " +
                                  this.state.dados.FATU_VALOR_NOTA_FISCAL.toLocaleString(
                                    "pt-BR",
                                    {
                                      maximumFractionDigits: 2,
                                      minimumFractionDigits: 2
                                    }
                                  )}
                              </TableCell>
                            </TableRow>

                            {(this.state.usuarioLogado.PerfCodigo ==
                              PERFIL_USUARIO_UNIDATA ||
                              this.state.usuarioLogado.PerfCodigo ==
                              PERFIL_USUARIO_COMERCIAL ||
                              this.state.usuarioLogado.PerfCodigo ==
                              PERFIL_USUARIO_FINANCEIRO) &&
                              this.state.dados.FATU_STATUS >=
                              STATUS_FATURA_ENVIADA_PARA_FATURAMENTO &&
                              this.state.dados.FATU_STATUS !=
                              STATUS_FATURA_CANCELADA_POR_CONTESTACAO && (
                                <TableRow
                                  classes={{ root: classes.rootRow }}
                                  key={"UsuarioPedido"}
                                >
                                  <TableCell
                                    variant="head"
                                    component="th"
                                    scope="row"
                                  >
                                    Usuário Pedido
                                  </TableCell>
                                  <TableCell
                                    style={{ fontWeight: 500 }}
                                    align="right"
                                  >
                                    {this.state.dados.USUA_NOME_ENVIO_FATURA +
                                      " (" +
                                      this.state.dados.USUA_EMAIL_ENVIO_FATURA +
                                      ")"}
                                  </TableCell>
                                </TableRow>
                              )}

                            {(this.state.usuarioLogado.PerfCodigo ==
                              PERFIL_USUARIO_UNIDATA ||
                              this.state.usuarioLogado.PerfCodigo ==
                              PERFIL_USUARIO_COMERCIAL ||
                              this.state.usuarioLogado.PerfCodigo ==
                              PERFIL_USUARIO_FINANCEIRO) &&
                              this.state.dados.FATU_STATUS >=
                              STATUS_FATURA_ENVIADA_PARA_FATURAMENTO &&
                              this.state.dados.FATU_STATUS !=
                              STATUS_FATURA_CANCELADA_POR_CONTESTACAO && (
                                <TableRow
                                  classes={{ root: classes.rootRow }}
                                  key={"DataPedido"}
                                >
                                  <TableCell
                                    variant="head"
                                    component="th"
                                    scope="row"
                                  >
                                    Data Pedido
                                  </TableCell>
                                  <TableCell
                                    style={{ fontWeight: 500 }}
                                    align="right"
                                  >
                                    {this.state.dados.FATU_DATA_ENVIO_FATURA}
                                  </TableCell>
                                </TableRow>
                              )}

                            {(this.state.usuarioLogado.PerfCodigo ==
                              PERFIL_USUARIO_UNIDATA ||
                              this.state.usuarioLogado.PerfCodigo ==
                              PERFIL_USUARIO_COMERCIAL ||
                              this.state.usuarioLogado.PerfCodigo ==
                              PERFIL_USUARIO_FINANCEIRO) &&
                              this.state.dados.FATU_STATUS >=
                              STATUS_FATURA_ENVIADA_PARA_FATURAMENTO &&
                              this.state.dados.FATU_STATUS !=
                              STATUS_FATURA_CANCELADA_POR_CONTESTACAO && (
                                <TableRow
                                  classes={{ root: classes.rootRow }}
                                  key={"NrPedido"}
                                >
                                  <TableCell
                                    variant="head"
                                    component="th"
                                    scope="row"
                                  >
                                    Número Pedido
                                  </TableCell>
                                  <TableCell
                                    style={{ fontWeight: 500 }}
                                    align="right"
                                  >
                                    {this.state.dados.FATU_NUMERO_PEDIDO}
                                  </TableCell>
                                </TableRow>
                              )}
                          </TableBody>
                        </Table>
                      </CardContent>
                    </Card>
                  ) : this.state.submitting ? (
                    <div />
                  ) : (
                    <div>
                      Nenhum faturamento encontrado para o identificador
                      solicitado.{" "}
                      <p>
                        <b>{this.state.mensagemErro}</b>
                      </p>
                      .
                    </div>
                  )}
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Blocker>
      </div>
    );
  }
}

Faturamento.propTypes = {
  classes: PropTypes.object.isRequired
};
function mapDispatchToProps(dispatch) {
  return bindActionCreators({ showAlert }, dispatch);
}

export default connect(
  null,
  mapDispatchToProps
)(withStyles(styles)(Faturamento));
